module.exports = __webpack_public_path__ + "img/qtpt.26a4c493.png";